<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42.5 41H38V10.5a2 2 0 00-2-2h-1V5a2 2 0 00-2-2H15a2 2 0 00-2 2v3.5h-1a2 2 0 00-2 2V41H5.5a1.5 1.5 0 000 3h37a1.5 1.5 0 000-3zM16 6h16v2.5H16zm11.5 35h-7v-8h7zm2 0v-9a1 1 0 00-1-1h-9a1 1 0 00-1 1v9H13V11.5h22V41z"/><path d="M21 25h-3.5a1 1 0 000 2H21a1 1 0 000-2zM30.5 25H27a1 1 0 000 2h3.5a1 1 0 000-2zM21 20h-3.5a1 1 0 000 2H21a1 1 0 000-2zM30.5 20H27a1 1 0 000 2h3.5a1 1 0 000-2zM21 15h-3.5a1 1 0 000 2H21a1 1 0 000-2zM30.5 15H27a1 1 0 000 2h3.5a1 1 0 000-2z"/></svg>